import { ROUTES } from "@/routes_new";
import { generatePath, Link, useParams } from "react-router-dom";
import LogoDark from "@/assets/images/allears-dark.svg";
import LogoLight from "@/assets/images/allears-light.svg";
import { useLingui } from "@lingui/react/macro";

export default function Logo({
  className,
  width = 60,
}: {
  className?: string;
  width?: number;
}) {
  const { t } = useLingui();
  const { orgUuid } = useParams<{ orgUuid: Uuid }>();

  return (
    <Link
      to={
        orgUuid
          ? generatePath(ROUTES.APP_HOME_ORGID, { orgUuid })
          : ROUTES.APP_HOME
      }
      className={className}
    >
      <LogoDark
        width={width}
        alt={t`All Ears Logotyp`}
        className="dark:hidden"
      />
      <LogoLight
        width={width}
        alt={t`All Ears Logotyp`}
        className="hidden dark:block"
      />
    </Link>
  );
}
